import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const GridContainer = ({ className, style, children }) => {
  return (
    <div className={cn(styles.gridContainer, className)} style={style}>
      {children}
    </div>
  );
};

const HeaderContainer = ({ style, children }) => {
  return (
    <GridContainer className={styles.header} style={style}>
      {children}
    </GridContainer>
  );
};

const BodyContainer = ({ style, children }) => {
  return (
    <GridContainer className={styles.body} style={style}>
      {children}
    </GridContainer>
  );
};

const BaseCell = ({ style, className, children }) => {
  return (
    <div style={style} className={cn(styles.baseCell, className)}>
      {children}
    </div>
  );
};

const CornerCell = () => {
  return <BaseCell className={styles.cornerCell} />;
};

const HeaderCell = ({ style, children }) => {
  return (
    <BaseCell style={style} className={cn(styles.headerCell, styles.text)}>
      {children}
    </BaseCell>
  );
};

const FirstColCell = ({ style, children }) => {
  return (
    <BaseCell style={style} className={cn(styles.firstColCell, styles.text)}>
      {children}
    </BaseCell>
  );
};

const Cell = ({ style, children, action, isOdd = false }) => {
  return (
    <BaseCell
      style={style}
      className={cn(styles.cell, isOdd ? styles.odd : styles.even)}
    >
      {action && <div className={styles.cellAction}>{action}</div>}
      {children && <div className={styles.cellContent}>{children}</div>}
    </BaseCell>
  );
};

export {
  HeaderContainer,
  BodyContainer,
  CornerCell,
  HeaderCell,
  FirstColCell,
  Cell,
};
